import React from 'react';
import Skills from './Skills';

const Hero = () => {
  const handleDownloadCV = () => {
    // Create a link element to trigger the download
    const link = document.createElement('a');
    link.href = '/CV Chun Ning Elvis Chu 2025.pdf';
    link.download = 'CV Chun Ning Elvis Chu 2025.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <header className="hero">
      <div className="hero-content-wrapper">
        <div className="name-title-overlay">
          <h1>Elvis Chu</h1>
          <p>Full Stack Developer & Infrastructure Engineer</p>
        </div>
        
        <Skills />
      </div>
      
      <div className="hero-actions">
        <button className="cv-download-btn" onClick={handleDownloadCV}>
          <span className="btn-icon">📄</span>
          Download CV
        </button>
      </div>
      
      <div className="scroll-indicator">
        <span>Scroll to explore my journey</span>
        <div className="arrow-down"></div>
      </div>
    </header>
  );
};

export default Hero; 